import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconNotificationSvg } from "./IconNotificationSvg.mjs";
const IconNotification = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconNotificationSvg, ...svgProps }) });
export {
  IconNotification
};
